var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isReady
    ? _c(
        "div",
        {
          attrs: {
            "data-page": "results",
            "data-content-width": "wide",
            "data-zip": this.search.attributes.zip,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "results-pane",
              class: _vm.loading ? "loading" : "",
            },
            [
              _c("list-component", {
                ref: "list",
                attrs: {
                  id: _vm.$route.params.id,
                  search: _vm.search,
                  response: _vm.response,
                },
                on: {
                  "goto-page": _vm.gotoPage,
                  "update-pagination": _vm.updatePagination,
                  "update-search": _vm.updateSearch,
                },
              }),
              _vm._v(" "),
              _c("footer-component", { attrs: { search: _vm.search } }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }